export default __webpack_public_path__ + "static/media/hoodie1.bfab80a6.webp";